import { useEffect } from "react";

const CancellationSurveyForm = () => {
  useEffect(() => {}, []);
  return (
    <>
      <div>
        <div className="container-fluid   position-relation">
          <div className="row team-directories g-3">
            <div className="col-xl-12">
              <div className="form-head d-flex flex-wrap align-items-center">
                <div className="me-auto">
                  <h2 className="font-w600 mb-0">Survey Form</h2>
                </div>
              </div>
            </div>
          </div>

          <div className="row w-100" style={{ padding: "33px 10px" }}>
            <div className="col-md-8">
              <form id="cancelSurveyForm">
                <h3>We're sorry to see you go!</h3>
                <p>Please help us improve by answering a few questions.</p>

                <div className="form-group-1">
                  <label for="reason">
                    What's the main reason you're canceling?
                  </label>
                  <select
                    id="reason"
                    name="reason"
                    className="form-control"
                    required
                  >
                    <option value="">-- Select Reason --</option>
                    <option value="too_expensive">Too expensive</option>
                    <option value="missing_features">
                      Missing features I need
                    </option>
                    <option value="technical_issues">
                      Had technical issues
                    </option>
                    <option value="not_user_friendly">Not user-friendly</option>
                    <option value="switching_competitor">
                      Switching to another Portal
                    </option>
                    <option value="temporary_need">
                      It was a temporary need
                    </option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-groups mt-3">
                  <label for="details">Can you tell us more?</label>
                  <textarea
                    id="details"
                    name="details"
                    className="form-control"
                    rows="4"
                    placeholder="Your feedback helps us improve..."
                  ></textarea>
                </div>

                <div className="form-groups mt-3">
                  <label>
                    Would you consider using our portal again in the future?
                  </label>
                  <br />
                  <label style={{padding: "5px 25px"}}>
                    <input
                      type="radio"
                      name="reconsider"
                      value="yes"
                      required
                    />{" "}
                    Yes
                  </label>
                  <label style={{padding: "5px 25px"}}>
                    <input type="radio" name="reconsider" value="maybe" /> Maybe
                  </label>
                  <label style={{padding: "5px 25px"}}>
                    <input type="radio" name="reconsider" value="no" /> No
                  </label>
                </div>

                <div className="form-groups mt-4">
                  <button type="submit" className="btn btn-danger">
                    Submit Feedback & Cancel Plan
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* </div>
        </div> */}
      {/* </div> */}
    </>
  );
};

export default CancellationSurveyForm;
